import React from 'react';

import Money from 'components/Money';

import './styles.css';

const Totals = ({overpayment}) => {
  return (
    <div className="Totals">
      <div className="section">
        <div className="header">Subtotal</div>
        <div className="value">
          <Money amount={overpayment.amount} />
        </div>
      </div>
      <div className="section">
        <div className="header">Total No Vat</div>
        <div className="value">
          <Money amount={0} />
        </div>
      </div>
    </div>
  );
};

export default Totals;
